(function(){"use strict";try{if(typeof document<"u"){var o=document.createElement("style");o.appendChild(document.createTextNode(".account-info[data-v-c1815f00]{display:flex;flex-direction:column;gap:16px;padding:16px;background-color:var(--color-bg-container);border-radius:8px}.account-info-header[data-v-c1815f00]{display:flex;align-items:center;gap:16px}.account-details[data-v-c1815f00]{display:flex;flex-direction:column;gap:4px}.username[data-v-c1815f00]{font-size:16px;font-weight:500;color:var(--color-text-primary)}.email[data-v-c1815f00]{font-size:14px;color:var(--color-text-secondary)}.account-info-footer[data-v-c1815f00]{display:flex;justify-content:flex-end}.login-prompt[data-v-c1815f00]{display:flex;flex-direction:column;gap:16px;padding:16px;background-color:var(--color-bg-container);border-radius:8px}.prompt-text[data-v-c1815f00]{font-size:16px;font-weight:500;color:var(--color-text-primary)}")),document.head.appendChild(o)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { defineComponent as x, resolveComponent as p, createElementBlock as h, openBlock as d, createElementVNode as n, createVNode as r, toDisplayString as i, unref as s, withCtx as u, createTextVNode as y, useSlots as B, computed as k, ref as D, watch as V, createBlock as I, renderSlot as S } from "vue";
import { UserOutlined as N } from "@gitcoffee/icons";
import { $t as c } from "@gitcoffee/i18n";
const O = { class: "setting-item" }, $ = {
  key: 0,
  class: "account-info"
}, b = { class: "account-info-header" }, A = { class: "account-details" }, P = { class: "username" }, z = { class: "credits" }, E = { class: "account-info-footer" }, F = {
  key: 1,
  class: "login-prompt"
}, L = { class: "account-info-header" }, T = { class: "account-details" }, j = { class: "prompt-text" }, q = { class: "account-info-footer" }, G = /* @__PURE__ */ x({
  __name: "AccountProfile",
  props: {
    userInfo: {},
    login: { type: Function },
    logout: { type: Function }
  },
  setup(t) {
    return (m, a) => {
      const l = p("a-avatar"), e = p("a-button");
      return d(), h("div", O, [
        t.userInfo?.nickname ? (d(), h("div", $, [
          n("div", b, [
            r(l, {
              size: 48,
              src: t.userInfo?.avatarUrl
            }, null, 8, ["src"]),
            n("div", A, [
              n("div", P, i(s(c)("setting.username")) + "：" + i(t.userInfo.nickname), 1),
              n("div", z, i(s(c)("setting.credits")) + "：" + i(t.userInfo?.credits), 1)
            ])
          ]),
          n("div", E, [
            r(e, {
              type: "primary",
              danger: "",
              onClick: t.logout
            }, {
              default: u(() => [
                y(i(s(c)("setting.logout")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])) : (d(), h("div", F, [
          n("div", L, [
            r(l, { size: 48 }, {
              icon: u(() => [
                r(s(N))
              ]),
              _: 1
            }),
            n("div", T, [
              n("div", j, i(s(c)("setting.notLoggedIn")), 1)
            ])
          ]),
          n("div", q, [
            r(e, {
              type: "primary",
              onClick: t.login
            }, {
              default: u(() => [
                y(i(s(c)("setting.loginNow")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      ]);
    };
  }
}), C = (t, m) => {
  const a = t.__vccOpts || t;
  for (const [l, e] of m)
    a[l] = e;
  return a;
}, H = /* @__PURE__ */ C(G, [["__scopeId", "data-v-c1815f00"]]), J = /* @__PURE__ */ x({
  __name: "UserSetting",
  props: {
    modelValue: { type: Boolean },
    settingData: {}
  },
  emits: ["update:modelValue"],
  setup(t, { emit: m }) {
    const a = t, l = m;
    B();
    const e = k({
      get: () => a.modelValue,
      set: (o) => {
        l("update:modelValue", o);
      }
    }), f = k(() => a.settingData || { openMode: "modal" }), v = D(f.value.openMode), U = k(() => v.value);
    return V(
      () => f.value.openMode,
      (o) => {
        !a.modelValue && o && (v.value = o);
      }
    ), V(e, (o) => {
      o || (v.value = f.value.openMode);
    }), (o, _) => {
      const w = p("a-modal"), M = p("a-drawer");
      return U.value === "modal" ? (d(), I(w, {
        key: 0,
        open: e.value,
        "onUpdate:open": _[0] || (_[0] = (g) => e.value = g),
        title: s(c)("common.setting"),
        footer: null,
        width: "600px"
      }, {
        default: u(() => [
          S(o.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["open", "title"])) : (d(), I(M, {
        key: 1,
        open: e.value,
        "onUpdate:open": _[1] || (_[1] = (g) => e.value = g),
        title: s(c)("common.setting"),
        placement: "right",
        footer: null,
        width: 600
      }, {
        default: u(() => [
          S(o.$slots, "default", {}, void 0, !0)
        ]),
        _: 3
      }, 8, ["open", "title"]));
    };
  }
}), K = /* @__PURE__ */ C(J, [["__scopeId", "data-v-16289880"]]), X = {
  install: (t) => {
    t.component("AccountProfile", H), t.component("UserSetting", K);
  }
};
export {
  H as AccountProfile,
  K as UserSetting,
  X as default
};
//# sourceMappingURL=index.mjs.map
